import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Globe, Users, TrendingUp, MessageSquare, Sparkles } from 'lucide-react';

const StatCard = ({ label, value, icon: Icon }) => (
  <div className="bg-white rounded-xl p-4 border border-green-200 text-center">
    <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center mx-auto mb-2">
      <Icon className="w-5 h-5 text-green-700" />
    </div>
    <p className="text-2xl font-bold text-green-800">{value}</p>
    <p className="text-xs text-gray-600">{label}</p>
  </div>
);

const OverviewSection = ({ toolkit }) => {
  const valueChains = toolkit.overview.valueChains;
  
  return (
    <div className="space-y-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
          <Globe className="w-6 h-6 text-green-700" />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Country Overview</h2>
          <p className="text-gray-600">Youth insights, value chains, and ecosystem context</p>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4">
        <StatCard label="Youth Population" value={toolkit.overview.keyStats.youthPopulation} icon={Users} />
        <StatCard label="Agriculture GDP" value={toolkit.overview.keyStats.agricultureGDP} icon={TrendingUp} />
        <StatCard label="Mobile Users" value={toolkit.overview.keyStats.mobileUsers} icon={MessageSquare} />
      </div>

      <Card className="border-2 border-green-200">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Users className="w-5 h-5 text-green-700" />
            Youth Insights
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-gray-700 leading-relaxed">{toolkit.overview.youthInsights}</p>
        </CardContent>
      </Card>

      <Card className="border-2 border-blue-200">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <TrendingUp className="w-5 h-5 text-blue-700" />
            Priority Value Chains
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-wrap gap-3">
            {valueChains.map((chain, idx) => (
              <span key={idx} className="px-3 py-1.5 bg-green-100 text-green-800 rounded-full text-sm font-medium">
                {chain}
              </span>
            ))}
          </div>
        </CardContent>
      </Card>

      <Card className="border-2 border-purple-200">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-purple-700" />
            Ecosystem Notes
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-gray-700 leading-relaxed">{toolkit.overview.ecosystemNotes}</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default OverviewSection;
